import { render, staticRenderFns } from "./TreeTableFooter.vue?vue&type=template&id=6ddeb273"
import script from "./TreeTableFooter.vue?vue&type=script&lang=js"
export * from "./TreeTableFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports